module.exports = __webpack_public_path__ + "static/img/jetpack_256.5e18f43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jetpack_256.png
// module id = 0TvY
// module chunks = 0